export default {
      id: "icon--swimming-usage",
      viewBox: "0 0 31.4 30",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--swimming-usage",
      toString: function () {
        return this.url;
      }
    }